/**
 * About Section Component
 * Personal introduction with stats and resume download
 */
import { Container, Row, Col, Button } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import DownloadIcon from '@mui/icons-material/Download';
import profilePic from '../assets/profile.jpeg'

const About = () => {
  // Intersection observer for scroll animations
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true
  });

  // Stats data
  const stats = [
    { number: '3+', label: 'Years Experience' },
    { number: '50+', label: 'Projects Completed' },
    { number: '30+', label: 'Happy Clients' },
  ];

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  return (
    <section id="about" className="about-section" ref={ref}>
      <Container>
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">About Me</h2>
          <p className="section-subtitle">Get to know me better</p>
        </motion.div>

        <Row className="align-items-center">
          {/* Profile Image */}
          <Col lg={5} className="mb-5 mb-lg-0 text-center">
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={inView ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="about-image-wrapper"
            >
              <img
                src={profilePic}
                alt="Profile"
                className="about-image"
              />
            </motion.div>
          </Col>

          {/* About Content */}
          <Col lg={7}>
            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate={inView ? "visible" : "hidden"}
              className="about-content"
            >
              <motion.h3 variants={itemVariants}>
                A Passionate Front-End Developer
              </motion.h3>

              
<motion.p variants={itemVariants}>
              Front-End / React Developer with over 5 years of experience, proficient in HTML, CSS, JavaScript, React, WordPress, PHP, and jQuery, working with modern frameworks and workflows. Experienced in building, enhancing, and maintaining responsive, accessible user interfaces, including API integrations and Redux Toolkit to optimize application performance and user engagement, with a strong focus on usability and WCAG/AODA compliance. Demonstrated ability to improve UI workflows and overall application quality through clean, maintainable code, modern front-end practices, and collaborative development. Worked in enterprise and education environments, including projects for media and e-learning platforms, supported by digital asset creation and attention to visual detail. </motion.p>

              {/* Resume Download Button */}
              <motion.div variants={itemVariants}>
                <Button
                  className="btn-primary-custom"
                  href="/resume.pdf"
                  download="Riddhi_frontend_developer_resume.pdf"
                  style={{ marginTop: '1rem' }}
                >
                  <DownloadIcon sx={{ mr: 1 }} />
                  Download Resume
                </Button>
              </motion.div>

              {/* Stats 
              <motion.div variants={itemVariants} className="about-stats">
                {stats.map((stat, index) => (
                  <div key={index} className="stat-item">
                    <div className="stat-number">{stat.number}</div>
                    <div className="stat-label">{stat.label}</div>
                  </div>
                ))}
              </motion.div>*/}
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;
